// Dependencies
import React, { memo, useRef } from 'react';
import PropTypes from 'prop-types';
import DocViewer, { PDFRenderer } from 'react-doc-viewer';
import {
  ColumnWidthOutlined,
  ExpandOutlined,
  LeftOutlined,
  RightOutlined,
  ZoomInOutlined,
  ZoomOutOutlined
} from '@ant-design/icons';

// Styles
require('./styles.css');

let zoomCount = 0;
let inFullScreen = false;
const PDFViewer = ({ url }) => {
  const pdfRenderFullScreen = useRef(null);

  const goFullScreen = (e) => {
    const appDiv = pdfRenderFullScreen.current;
    e.preventDefault();
    if (appDiv.requestFullscreen) {
      appDiv.requestFullscreen();
    } else if (appDiv.webkitRequestFullscreen) {
      /* Safari */
      appDiv.webkitRequestFullscreen();
    } else if (appDiv.msRequestFullscreen) {
      /* IE11 */
      appDiv.msRequestFullscreen();
    }
  };

  const pdfPreviewButton = {
    width: 32,
    height: 32,
    padding: 8,
    borderRadius: 5,
    borderStyle: 'solid',
    borderWidth: 1,
    flexGrow: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 10
  };

  const changeZoom = (zoomType) => {
    const element = document.querySelector('.react-pdf__Page__canvas');
    const { width, height } = element.style;
    const widthNumber = Number(width.substr(0, width.length - 2));
    const heightNumber = Number(height.substr(0, height.length - 2));
    switch (zoomType) {
      case 'in':
        element.style.width = `${widthNumber + 30}px`;
        element.style.height = `${heightNumber + 30}px`;
        zoomCount += 1;
        break;
      case 'out':
        element.style.width = `${widthNumber - 30}px`;
        element.style.height = `${heightNumber - 30}px`;
        zoomCount -= 1;
        break;
      default:
        element.style.width = `${widthNumber - zoomCount * 30}px`;
        element.style.height = `${heightNumber - zoomCount * 30}px`;
        zoomCount = 0;
        break;
    }
  };
  const navigationButton = (
    <div className="flex flex-wrap bg-white justify-between px-3 pb-2">
      <button
        className="text-baxterTale"
        style={pdfPreviewButton}
        onClick={() => {
          const prev = document.getElementById('pdf-pagination-prev');
          prev.click();
        }}>
        <LeftOutlined />
      </button>
      <button
        className="text-baxterTale"
        style={pdfPreviewButton}
        onClick={() => {
          const next = document.getElementById('pdf-pagination-next');
          next.click();
        }}>
        <RightOutlined />
      </button>
      <button
        className="text-baxterTale"
        style={pdfPreviewButton}
        onClick={() => {
          changeZoom('in');
        }}>
        <ZoomInOutlined />
      </button>
      <button
        className="text-baxterTale"
        style={pdfPreviewButton}
        onClick={() => {
          changeZoom('out');
        }}>
        <ZoomOutOutlined />
      </button>
      <button
        className="text-baxterTale"
        style={pdfPreviewButton}
        onClick={() => {
          if (zoomCount) {
            changeZoom();
          }
        }}>
        <ColumnWidthOutlined />
      </button>
      <button
        className="text-baxterTale"
        style={pdfPreviewButton}
        onClick={(e) => {
          if (inFullScreen) {
            document.exitFullscreen();
          } else {
            goFullScreen(e);
          }
          inFullScreen = !inFullScreen;
        }}>
        <ExpandOutlined />
      </button>
    </div>
  );

  return (
    <>
      <div ref={pdfRenderFullScreen} className="overflow-scroll">
        {navigationButton}
        <div id="pdf-container"></div>
        <DocViewer
          pluginRenderers={[PDFRenderer]}
          config={{
            header: {
              disableHeader: false,
              disableFileName: false,
              retainURLParams: true
            }
          }}
          documents={[{ uri: url, fileType: 'pdf' }]}
        />
        {navigationButton}
      </div>
    </>
  );
};

/**
 * Component definition of proptypes
 */
PDFViewer.propTypes = {
  url: PropTypes.string.isRequired
};

export default memo(PDFViewer);
